import React, { CSSProperties, PropsWithChildren } from "react";
import { BaseComponentProps } from "../../../../common/types/Data/BaseComponentProps";
import { YoutubeSearchResult } from "../../../../common/Youtube/YoutubeSearchResult";
import { WithContentNavigator, withContentNavigator } from "../../../hocs/ContentNavigator/withContentNavigator";
import { withActions, WithActions } from "../../../hocs/withActions";
import { WithAnalytics, withAnalytics } from "../../../hocs/withAnalytics";
import { ModulePreview } from "../Common/ModulePreview";
import { ModulePreviewHeader } from "../Common/ModulePreviewHeader";
import { ModulePreviewImage } from "../Common/ModulePreviewImage";

export type Props = BaseComponentProps<YoutubeSearchResult> & {};

const buildBackgroundStyle = (youtubeSearchResult: YoutubeSearchResult): CSSProperties => {
    return {
        backgroundImage: `url(${youtubeSearchResult.snippet.thumbnails.high.url})`,
        backgroundSize: "cover",
    };
};

const YoutubeVideoBaseModuleDecorated = (props: PropsWithChildren<Props & WithActions & WithAnalytics & WithContentNavigator>) => {
    const {
        entity,
        contentNavigator,
        analyticsUtils: { trackClickModuleEvent },
        nested,
    } = props;

    const onClick = () => {
        trackClickModuleEvent(entity);
        contentNavigator.open("youtube:video", { entity }, { nested });
    };

    const style = buildBackgroundStyle(entity.linkedContent);

    return (
        <ModulePreview classNames={["VideoModule", "GalleryImage"]} onClick={onClick}>
            <ModulePreviewHeader className={"video"} label={entity.label} />
            <ModulePreviewImage entity={entity} file={undefined} style={style} noConditional={true} />
        </ModulePreview>
    );
};

export const YoutubeVideoBaseModule = withContentNavigator(withAnalytics(withActions(YoutubeVideoBaseModuleDecorated)));
